import styled from "styled-components";

export const SearchField = styled.div`
  width: 100%;
  // float: right;
  display: flex;
  justify-content: flex-end;

  .search-bar {
    width: 260px;
    font-weight: 400;
  }
  .search-bar {
    border: 1px solid #e1e1e1;
    box-shadow: none;
    max-width: 260px;
    height: 40px;
    display: inline-block;
  }
  .form-control {
    display: block;
    width: 100%;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  .form-control:focus {
    border-color: #66afe9;
    outline: 0;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%),
      0 0 8px rgb(102 175 233 / 60%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
  }

  @media only screen and (max-width: 730px) {
    justify-content: flex-start;
    width: 100%;
  }
`;

export const StyledContainer = styled.div`
    & .blue-btn {
        background-color: #1d4f4b;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        padding: 7px 25px;
        display: inline-block;
        border: none;
        margin: 23px 3px;
        border-radius: 4px;
    }
`;

export const StyledPageTitle = styled.div`
  background: #8a1537;
  color: #fff;
  border-radius: 5px;
  padding: 10px 25px;
  margin-bottom: 20px;

  & h1 {
    font-size: 20px;
    color: #ffffff;
    font-weight: 600;
  }
`;

export const StyledOrderBlock = styled.div`
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  padding: 15px 25px;
  margin-bottom: 20px;

  @media only screen and (max-width: 767px) {
    padding: 15px;
  }

  .table-block table {
    width: 100%;
  }

  .table-block table th {
    font-weight: 600;
    font-size: 18px;
    padding: 10px;

    @media only screen and (max-width: 767px) {
      font-weight: 600;
      font-size: 15px;
      padding: 5px;
    }
  }
  .table-block table td {
    border-top: 1px solid #e8f5ff;
    font-size: 16px;
    padding: 10px;
    vertical-align: top;
    @media only screen and (max-width: 767px) {
      font-size: 14px;
      padding: 5px;
    }
  }

  .dMpKVF {
    display: flex;
    -webkit-box-align: stretch;
    align-items: stretch;
    align-content: stretch;
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.87);
    background-color: rgb(255, 255, 255);
    min-height: 80px !important;
  }s
  .table-block table tr:nth-child(even) td {
    background: #f9fcff;
  }

  @media only screen and (max-width: 767px) {
    .table-block.table-responsive {
      border: 0px;
    }
  }
  & div:first-child {
    white-space: pre-line;
    text-overflow: ellipsis;
    // min-width: fit-content;
  }
`;




